/**
 * Outline SVG icon module.
 */
import * as React from "react";
/**
 * User (outline) SVG icon. Generated wrapper that forwards props to the root svg.
 *
 * @param {React.SVGProps<SVGSVGElement>} props SVG element props.
 * @returns {JSX.Element}
 */
const SvgUser = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="33 31 18 22"
    fill="none"
    {...props}
  >

    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    >
      <path d="M44.828 39.828a4 4 0 1 0-5.656-5.656 4 4 0 0 0 5.656 5.656M37.05 46.05A7 7 0 0 1 49 51H35a7 7 0 0 1 2.05-4.95" />
    </g>
  </svg>
);
export default SvgUser;
